import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import styled from 'styled-components';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { toast } from '../../../../redux/action';
import { emergencyCancel } from '../../actions';
import { getMinutesRemaining, isEmergencyCancelOpen } from '../../utils/status';
import { BLUE } from '../../AnalyticsV2.styled';

const Link = styled.button`
  border: none;
  background: none;
  padding: 0;
  font-size: 14px;
  color: ${BLUE};
  cursor: pointer;
  white-space: nowrap;
`;

// "Emergency Cancel [x min remaining]" for a sending message, counting down
// every second. It disappears when the queued send starts.
const EmergencyCancel = ({ message, onCancelled }) => {
  const dispatch = useDispatch();
  const [now, setNow] = useState(moment().unix());
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isCancelling, setCancelling] = useState(false);
  const isOpen = isEmergencyCancelOpen(message, now);

  useEffect(() => {
    if (!isOpen) return undefined;
    const interval = setInterval(() => setNow(moment().unix()), 1000);
    return () => clearInterval(interval);
  }, [isOpen]);

  if (!isOpen && !isDialogOpen) return null;

  const handleConfirm = async () => {
    setCancelling(true);
    await emergencyCancel(message.id);
    setCancelling(false);
    setDialogOpen(false);
    dispatch(toast('success', 'Message cancelled.'));
    onCancelled();
  };

  return (
    <>
      {isOpen && (
        <Link onClick={() => setDialogOpen(true)}>
          Emergency Cancel [{getMinutesRemaining(message.standbySendTime, now)}{' '}
          min remaining]
        </Link>
      )}
      <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Cancel this message?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Emails and texts for &quot;{message.draftName}&quot; that have not
            gone out yet will not be sent. This can&apos;t be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} disabled={isCancelling}>
            Keep sending
          </Button>
          <Button
            onClick={handleConfirm}
            color="secondary"
            disabled={isCancelling}
          >
            {isCancelling ? 'Cancelling…' : 'Cancel message'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EmergencyCancel;
